import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { FirebaseErrorSources } from '@constants/firebase';
import ServerError from '@components/server-error';
import { reportUiError } from '@helpers/firebase-error';
import { useCommons } from '@hooks/use-commons';
function getRouteErrorDetails(error) {
    if (isRouteErrorResponse(error)) {
        return {
            message: error.statusText || "Route error ".concat(error.status),
            errorType: 'RouteErrorResponse'
        };
    }
    if (error instanceof Error) {
        return {
            message: error.message,
            errorType: error.name,
            stack: error.stack
        };
    }
    return {
        message: typeof error === 'string' ? error : 'Unknown route error',
        errorType: 'Error'
    };
}
var ServerErrorWrapper = function () {
    var routeError = useRouteError();
    var isBotUser = useCommons().isBotUser;
    useEffect(function () {
        if (isBotUser)
            return;
        var _a = getRouteErrorDetails(routeError), message = _a.message, errorType = _a.errorType, stack = _a.stack;
        reportUiError({
            source: FirebaseErrorSources.ERROR_BOUNDARY,
            message: message,
            errorType: errorType,
            stack: stack
        });
    }, [routeError, isBotUser]);
    return _jsx(ServerError, {});
};
export default ServerErrorWrapper;
